<!-- ============ TOOLBAR ============ -->
<div class="ad-toolbar" *ngIf="!formOnly">
  <div class="ad-toolbar-left">
    <span class="ad-toolbar-title">Addresses</span>
    <span class="ad-count-badge" *ngIf="AddressList.length">{{ AddressList.length }}</span>
  </div>

  <div class="ad-toolbar-right">
    <div class="ad-view-switch" *ngIf="!calledInUIC" role="group" aria-label="View switcher">
      <button type="button" class="ad-view-btn" [class.active]="currentView === 'card'" (click)="setView('card')"
        title="Card View" aria-label="Card View">
        <i class="bi bi-grid-fill"></i>
      </button>
      <button type="button" class="ad-view-btn" [class.active]="currentView === 'list'" (click)="setView('list')"
        title="List View" aria-label="List View">
        <i class="bi bi-list-ul"></i>
      </button>
    </div>

    <button type="button" class="btn btn-sm btn-primary ad-add-btn" (click)="addAddress()">
      <i class="bi bi-plus-lg me-1"></i> Add Address
    </button>
  </div>
</div>

<!-- ============ FORM PANEL ============ -->
<div class="ad-form-panel" *ngIf="editMode" @accordionAnimation>
  <div class="ad-form-header">
    <span class="ad-form-header-icon"><i class="bi bi-geo-alt-fill"></i></span>
    <div class="ad-form-header-text">
      <h6 class="ad-form-title">
        {{ addressDetailForm.controls.addressId.value ? 'Edit Address Detail' : 'Add Address Detail' }}
      </h6>
    </div>
    <button type="button" class="ad-form-close" (click)="resetForm()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="ad-form-body">
    <form [formGroup]="addressDetailForm" novalidate>
      <div class="row g-3">

        <!-- Address Type (Value List driven - VlCode is configurable per page) -->
        <div class="col-12 col-md-6 col-xl-4">
          <label class="ad-label">
            Address Type <span class="ad-required">*</span>
          </label>
          <ng-select class="ad-ng-select" [items]="addressTypeOptions" formControlName="addressType"
            placeholder="Select address type" [clearable]="true" appendTo="body">
          </ng-select>
          <app-form-errors [control]="addressDetailForm.controls.addressType"></app-form-errors>
        </div>

        <!-- Country -->
        <div class="col-12 col-md-6 col-xl-4">
          <label class="ad-label">Country</label>
          <input type="text" class="form-control form-control-sm" formControlName="country"
            placeholder="e.g. India">
        </div>

        <!-- State -->
        <div class="col-12 col-md-6 col-xl-4">
          <label class="ad-label">State</label>
          <input type="text" class="form-control form-control-sm" formControlName="state"
            placeholder="e.g. Maharashtra">
        </div>

        <!-- Address -->
        <div class="col-12">
          <label class="ad-label">
            Address <span class="ad-required">*</span>
          </label>
          <textarea class="form-control form-control-sm ad-textarea" rows="3" formControlName="address"
            placeholder="Building / street / area / landmark"></textarea>
          <app-form-errors [control]="addressDetailForm.get('address')"></app-form-errors>
        </div>

        <!-- City -->
        <div class="col-12 col-md-6 col-xl-4">
          <label class="ad-label">City <span class="ad-required" *ngIf="requireCity">*</span></label>
          <input type="text" class="form-control form-control-sm" formControlName="city" placeholder="e.g. Pune">
          <app-form-errors *ngIf="requireCity" [control]="addressDetailForm.controls.city"></app-form-errors>
        </div>

        <!-- Pincode -->
        <div class="col-12 col-md-6 col-xl-4">
          <label class="ad-label">Pincode</label>
          <input type="text" class="form-control form-control-sm" formControlName="pincode"
            placeholder="e.g. 411001" maxlength="12">
        </div>

        <!-- Mark as default -->
        <div class="col-12 col-xl-4 d-flex align-items-end">
          <label class="ad-default-toggle" for="adIsDefault">
            <input class="form-check-input" type="checkbox" id="adIsDefault" formControlName="isDefault">
            <span class="ad-default-text">
              <span class="ad-default-title">
                <i class="bi bi-check-circle-fill me-1"></i>Set as default address
              </span>
              <small class="ad-default-hint">Any other default address will be cleared</small>
            </span>
          </label>
        </div>

      </div>
    </form>
  </div>

  <div class="ad-form-footer">
    <button type="button" class="btn btn-sm btn-light ad-btn-cancel" (click)="resetForm()">Cancel</button>
    <button type="button" class="btn btn-sm btn-primary" (click)="submitForm()">
      <i class="bi bi-check2 me-1"></i>{{ calledInUIC ? 'Save' : 'Submit' }}
    </button>
  </div>
</div>

<!-- ============ LOADING ============ -->
<div class="ad-loading" *ngIf="isDataLoading">
  <div class="spinner-border spinner-border-sm text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <span class="ad-loading-text">Loading addresses...</span>
</div>

<!-- ============ EMPTY STATE ============ -->
<div class="ad-empty" *ngIf="!formOnly && !isDataLoading && !AddressList.length && !calledInUIC">
  <div class="ad-empty-icon"><i class="bi bi-geo-alt"></i></div>
  <h6 class="ad-empty-title">No address details yet</h6>
  <p class="ad-empty-text">Add an address to keep location records complete.</p>
  <button type="button" class="btn btn-sm btn-primary" (click)="addAddress()" *ngIf="!editMode">
    <i class="bi bi-plus-lg me-1"></i> Add Address
  </button>
</div>

<!-- ============ CARD VIEW ============ -->
<div class="addresses-grid-container" *ngIf="!formOnly && currentView === 'card' && AddressList.length && !isDataLoading">
  <div class="address-card-wrapper" *ngFor="let address of AddressList">
    <div class="ad-card">

      <div class="ad-card-header">
        <span class="ad-type-icon"><i class="bi bi-geo-alt-fill"></i></span>

        <div class="ad-card-heading">
          <h6 class="ad-card-type" [title]="address.addressType">{{ address.addressType || 'Address' }}</h6>
          <span class="ad-chip ad-chip-default" *ngIf="address.isDefault === 1">
            <i class="bi bi-check-circle-fill"></i> Default
          </span>
        </div>

        <div class="dropdown ad-card-menu">
          <button class="ad-kebab" data-bs-toggle="dropdown" aria-label="Actions" aria-expanded="false">
            <i class="bi bi-three-dots-vertical"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end shadow-sm">
            <li>
              <button type="button" class="dropdown-item"
                (click)="handleActionClick({actionName: 'Edit', rowData: address})">
                <i class="bi bi-pencil-square me-2"></i>Edit
              </button>
            </li>
            <li>
              <button type="button" class="dropdown-item"
                (click)="defaultCheckBox({rowData: address, isChecked: address.isDefault !== 1})">
                <i class="bi bi-check-circle me-2"></i>{{ address.isDefault === 1 ? 'Remove Default' : 'Set as Default' }}
              </button>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li>
              <button type="button" class="dropdown-item text-danger"
                (click)="handleActionClick({actionName: 'Delete', rowData: address})">
                <i class="bi bi-trash3 me-2"></i>Delete
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div class="ad-card-body">
        <p class="ad-address-line" [title]="address.address">
          {{ address.address || 'No address captured' }}
        </p>

        <div class="ad-meta-grid">
          <div class="ad-meta" *ngIf="address.city">
            <span class="ad-meta-icon"><i class="bi bi-buildings"></i></span>
            <div class="ad-meta-text">
              <small class="ad-meta-label">City</small>
              <span class="ad-meta-value" [title]="address.city">{{ address.city }}</span>
            </div>
          </div>
          <div class="ad-meta" *ngIf="address.state">
            <span class="ad-meta-icon"><i class="bi bi-flag"></i></span>
            <div class="ad-meta-text">
              <small class="ad-meta-label">State</small>
              <span class="ad-meta-value" [title]="address.state">{{ address.state }}</span>
            </div>
          </div>
          <div class="ad-meta" *ngIf="address.country">
            <span class="ad-meta-icon"><i class="bi bi-globe2"></i></span>
            <div class="ad-meta-text">
              <small class="ad-meta-label">Country</small>
              <span class="ad-meta-value" [title]="address.country">{{ address.country }}</span>
            </div>
          </div>
          <div class="ad-meta" *ngIf="address.pincode">
            <span class="ad-meta-icon"><i class="bi bi-crosshair"></i></span>
            <div class="ad-meta-text">
              <small class="ad-meta-label">Pincode</small>
              <span class="ad-meta-value">{{ address.pincode }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ============ LIST VIEW ============ -->
<div *ngIf="!formOnly && currentView === 'list' && !isDataLoading" class="ad-list-wrap">
  <app-color-table [columns]="tableCol" [tableData]="AddressList" [enableActionColumn]="true"
    [actionColumnLabel]="'Action'" [checkboxStateBinding]="'status'" (actionClick)="handleActionClick($event)"
    [actionOptions]="[ {actionName:'Edit',actionIcon:'fa fa-edit'},{actionName:'Delete',actionIcon:'fa fa-trash'},{actionName:'Default', actionIcon:'fa fa-check-circle'} ]">
  </app-color-table>
</div>
